import React from 'react';
import { Button, Modal, Space } from 'antd';
import { useI18n } from '../i18n';

export default function CounterpartyTypeModal({ open, onCancel, onSelect }) {
  const { t } = useI18n();
  return (
    <Modal
      title={t('Create Counterparty')}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={420}
    >
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        <Button type="primary" block size="large" onClick={() => onSelect('client')}>
          {t('Client')}
        </Button>
        <Button block size="large" onClick={() => onSelect('supplier')}>
          {t('Supplier')}
        </Button>
      </Space>
    </Modal>
  );
}
